import * as styles from './ScrollToTopButton.module.css';

export function scrollToTopGradually() {
  let scrollTop;
  if (document.documentElement !== null && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body !== null) {
    scrollTop = document.body.scrollTop;
  } else {
    scrollTop = 0;
  }
  if (scrollTop > 0) {
    window.requestAnimationFrame(scrollToTopGradually);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

function ScrollToTopButton() {
  return (
    <button
      className={`naked-button ${styles.button}`}
      onClick={scrollToTopGradually}
      type="button"
    >
      scroll to top
    </button>
  );
}

export default ScrollToTopButton;
